import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { MonoTypeOperatorFunction, retry, throwError, timer } from 'rxjs';

const TRANSIENT_NAVIGATION_RETRY_COUNT = 3;
const TRANSIENT_NAVIGATION_RETRY_DELAY_MS = 1000;

const isTransientNavigationError = (error: unknown): boolean => {
  if ((error as { name?: string })?.name === 'TimeoutError') {
    return true;
  }

  if (!(error instanceof HttpErrorResponse)) {
    return false;
  }

  return error.status === 0 || error.status === HttpStatusCode.TooManyRequests || error.status >= HttpStatusCode.InternalServerError;
};

export const retrySurveyNavigation = <T>(): MonoTypeOperatorFunction<T> =>
  retry({
    count: TRANSIENT_NAVIGATION_RETRY_COUNT,
    delay: (error: unknown, retryCount: number) => {
      if (!isTransientNavigationError(error)) {
        return throwError(() => error);
      }

      return timer(retryCount * TRANSIENT_NAVIGATION_RETRY_DELAY_MS);
    }
  });
